'use strict';

export default function chartConfig(scope) {
  'ngInject';

  return {
    chart: {
      type: 'column',
      height: 250,
      events: {
        load: function () {
          // Highcharts オブジェクトへの参照をコンパクトに実現するため、arrow function を用いない
          scope.chart = this;
        }
      }
    },
    colors: ['#2b908f'],
    title: {
      text: '時間毎の平均デマンド値',
      style: { fontSize: '14px' }
    },
    legend: {enabled: false},
    xAxis: {
      categories: scope.ticks,
      crosshair: true,
    },
    yAxis: {
      labels: {
        format: '{value}'
      },
      title: {
        text: 'デマンド値の平均 [kW]',
        style: {'font-size': '13px'}
      }
    },
    tooltip: {
      enabled: true,
      shared: true,
      formatter: function () {
        let tip_format = "<tspan style='font-size: 12px'>" + this.x + "</tspan>";

        let point = this.points[0];
        tip_format += '<br/><span style="color:' + point.series.color + ';font-size: 12px">\u25CF</span> <span style="font-size: 14px;">' + point.series.name + ': ';
        tip_format += point.y + " kW";
        tip_format += "</span>";

        return tip_format;
      }
    },
    plotOptions: {
      column: {grouping: false}
    },
    series: [
      {
        name: 'デマンド値の平均',
        color: '#1F85CF'
      }
    ]
  };
}



// WEBPACK FOOTER //
// ./public/dev/app/statistics_report/power-stat-graph/demand-power/power-stat-graph-demand.config.js